import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableChildRow } from "../types";

const ModulePullRequestsTableRunOpenedAtCell = ({
  item: { run },
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableChildRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={run.createdAt} />
    </TableSimpleCell>
  );
};

export default ModulePullRequestsTableRunOpenedAtCell;
